import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Col, Container, Row, Accordion, Card, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, concat } from 'lodash';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NewCommonMultiSelect from '../../Components/Utility/FilterAction/NewCommonMultiSelect';
import {
  activeInactiveAction,
  addProductCard,
  addProductCpTabs,
  clearIndividualReducer,
  deletePCPTabs,
  deleteTabsColumns,
  duplicateProductCard,
  fetchSuppliers,
  getAllProductcpTabs,
  getIndividualDetails,
  rearrangeTabs,
} from './store/ProductCP.action';
import { fetchUserGroupsCards } from '../UserSetting/store/User.action';
import {
  clearLicenseData,
  clearLikenessData,
  clearMultiSubBrandData,
  getBrandDetails,
  getCatBasedOnPT,
  getCategory1Details,
  getCategory2Details,
  getMultipleCatgory,
  getMultiSubBrandDetails,
  getPCTypesDetails,
  getProductStatusDetails,
  getSeasonsDetails,
  getSubBrandAccess,
} from '../SystemMasters/Store/SystemMasters.action';
import { lastOpened } from '../OprationalCP/store/OprationalCP.action';
import { YearsWithId, months } from '../../Components/helper';
import AddEditColumn from './Modals/AddEditColumn';
import RenderProductCpColumnsTable from './RenderProductCpColumnsTable';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import DragDrogRearrange from '../../Components/DragDrogRearrange/DragDrogRearrange';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';
import { toasterMsg } from '../../Components/Toaster/Toaster';

function AddEditProductCP() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation('common');
  const duplicateDetails = location?.state;
  const basedOnPOFromState = location?.state?.basedOnPO;

  const [pcpCreationState, setPcpCreationState] = useState({
    basedOnPO: basedOnPOFromState ?? false,
    expandColourway: true,
    expandSupplierFactory: true,
  });
  const {
    SystemMastersDetails: {
      brandList,
      seasonList,
      category1List,
      category2List,
      pcTypeList,
      multipleCategory3,
      multipleCategory4,
      productStatusList,
      multiSubBrandList,
    },
    UserDetails: { userInfo },
    Users: { logInRights },
    ProductCPReducer: { supplierList, individualDetail, productCpTabs },
  } = useSelector((reducer) => reducer);
  const { CheckActionPermission } = useComponent();
  const productAddEditAccess = CheckActionPermission(logInRights, 'criticalPath', 'product', 'addEdit');
  const productDeleteAccess = CheckActionPermission(logInRights, 'criticalPath', 'product', 'delete');
  const loggedInUserId = userInfo?.userId;
  const commonParam = {
    loggedInUserId,
    isActive: true,
  };

  const cat2Params = {
    accessedFrom: '',
    categoryType: 2,
    loggedInUserId,
    isActive: true,
  };
  const cat1Params = {
    accessedFrom: '',
    categoryType: 1,
    loggedInUserId,
    isActive: true,
  };

  const [addEditState, setAddEditState] = useState({
    name: '',
    brand: [],
    subBrand: [],
    season: [],
    year: [],
    category_1: [],
    category_2: [],
    category_3: [],
    category_4: [],
    product_Type: [],
    suppliers: [],
    status: [],
    category3List: [],
    category4List: [],
    month: [],
    hasError: false,
    charCount: 0,
    isLoading: false,
    showColumnModal: false,
    selectedTab: null,
    Tabs: [],
    tabId: null,
    selectAllcolumns: false,
    editIndex: -1,
    editTabData: null,
    editColumnData: null,
    _id: '',
    isDragging: false,
    isColumnDragging: false,
    showDeleteConfirmation: false,
    deleteIndex: -1,
    deleteIds: [],
    fromModal: '',
    showRearrangeModal: false,
    showTabDeleteModal: false,
    deleteTab: null,
    subBrandAccess: false,
  });
  const lockedcat1Ids = individualDetail?.catOneId?.map((cat) => cat._id) || [];
  const lockedcat2Ids = individualDetail?.catTwoId?.map((cat) => cat._id) || [];
  const lockedcat3Ids = individualDetail?.catThreeId?.map((cat) => cat._id) || [];
  const lockedcat4Ids = individualDetail?.catFourId?.map((cat) => cat._id) || [];
  const [arrayDirection, setArrayDirection] = useState([]);
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);
  const prevIdRef = useRef(id);

  const checkNullInArrayIds = (array) => {
    return array?.filter((ele) => ele)?.map((e) => e?._id);
  };
  useEffect(() => {
    const fetchLicensorAccess = async () => {
      const subBrandAccessRes = await dispatch(getSubBrandAccess());
      setAddEditState((prev) => ({ ...prev, subBrandAccess: subBrandAccessRes?.data || false }));
    };
    fetchLicensorAccess();
  }, [dispatch]);

  useEffect(() => {
    const fetchFlag = async () => {
      try {
        const res = await dispatch(getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchFlag();
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(addEditState?.brand)) {
      dispatch(getMultiSubBrandDetails({ brandId: addEditState.brand }));
    }
  }, [addEditState?.brand, dispatch]);
  useEffect(() => {
    const initialFunctions = async () => {
      if (id) {
        if (!duplicateDetails?._id) {
          await dispatch(getIndividualDetails(id));
        }
        dispatch(getAllProductcpTabs({ productCPId: id }));
      }
      Promise.all([
        dispatch(fetchUserGroupsCards({ fromPCP: id })),
        dispatch(getBrandDetails({ isActive: true })),
        dispatch(getSeasonsDetails(commonParam)),
        dispatch(getCategory1Details(cat1Params)),
        dispatch(getCategory2Details(cat2Params)),
        dispatch(
          getPCTypesDetails({
            isActive: true,
            tier: 'Tier1',
          }),
        ),
        dispatch(
          getProductStatusDetails({
            loggedInUserId: userInfo?.userId,
            isActive: 1,
          }),
        ),
        dispatch(fetchSuppliers({ alphabaticallySorted: true })),
      ]);
    };
    initialFunctions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  useEffect(() => {
    if (!duplicateDetails?._id && individualDetail) {
      const lastOpenedParams = {
        modalId: id,
        userId: loggedInUserId,
        type: 'productCP',
      };
      dispatch(lastOpened(lastOpenedParams));
    }
  }, [individualDetail, dispatch, duplicateDetails?._id, id, loggedInUserId]);

  useEffect(() => {
    const prevId = prevIdRef.current;
    if (prevId && !id && !duplicateDetails?._id) {
      dispatch(clearIndividualReducer());
      dispatch(clearMultiSubBrandData());
    }
    prevIdRef.current = id;
  }, [id, duplicateDetails?._id, dispatch]);

  useEffect(() => {
    return () => {
      if (!id && !duplicateDetails?._id) {
        dispatch(clearIndividualReducer());
        dispatch(clearMultiSubBrandData());
      }
    };
  }, [id, duplicateDetails?._id, dispatch]);

  useEffect(() => {
    setAddEditState((prev) => ({ ...prev, Tabs: productCpTabs }));
  }, [productCpTabs]);

  useEffect(() => {
    if (!isEmpty(addEditState?.category_1) && !isEmpty(addEditState?.category_2)) {
      const callCategory3Api = async () => {
        const cat3params = {
          categoryOneId: addEditState?.category_1,
          categoryTwoId: addEditState?.category_2,
          categoryType: 3,
          loggedInUserId,
          isActive: true,
        };
        await dispatch(getMultipleCatgory(cat3params, false));
      };
      callCategory3Api();
    }
  }, [addEditState?.category_1, addEditState?.category_2, dispatch, loggedInUserId]);

  useEffect(() => {
    if (!isEmpty(addEditState?.category_1) && !isEmpty(addEditState?.category_2) && !isEmpty(addEditState?.category_3)) {
      const callCategory4Api = async () => {
        const cat4params = {
          categoryOneId: addEditState?.category_1,
          categoryTwoId: addEditState?.category_2,
          categoryThreeId: addEditState?.category_3,
          categoryType: 4,
          loggedInUserId,
          isActive: true,
        };
        await dispatch(getMultipleCatgory(cat4params));
      };
      callCategory4Api();
    }
  }, [addEditState?.category_1, addEditState?.category_2, addEditState?.category_3, dispatch, loggedInUserId]);

  useEffect(() => {
    if (addEditState?.category_1 && !isEmpty(addEditState?.category_1) && addEditState?.category_2 && !isEmpty(addEditState?.category_2)) {
      setAddEditState((oldData) => ({
        ...oldData,
        category3List: [...multipleCategory3],
      }));
    }
    if (
      addEditState?.category_1 &&
      !isEmpty(addEditState?.category_1) &&
      addEditState?.category_2 &&
      !isEmpty(addEditState?.category_2) &&
      addEditState?.category_3 &&
      !isEmpty(addEditState?.category_3)
    ) {
      setAddEditState((oldData) => ({
        ...oldData,
        category4List: [...multipleCategory4],
      }));
    }
  }, [multipleCategory3, multipleCategory4, addEditState?.category_1, addEditState?.category_2, addEditState?.category_3]);

  useEffect(() => {
    const prevId = prevIdRef.current;
    const transitioningFromEditToCreate = prevId && !id && !duplicateDetails?._id;

    if (individualDetail && id && !transitioningFromEditToCreate) {
      setPcpCreationState({
        basedOnPO: individualDetail.basedOnPO ?? false,
        expandColourway: individualDetail.expandColourway ?? true,
        expandSupplierFactory: individualDetail.expandSupplierFactory ?? true,
      });
    } else if (duplicateDetails?._id) {
      setPcpCreationState({
        basedOnPO: duplicateDetails.basedOnPO ?? false,
        expandColourway: duplicateDetails.expandColourway ?? true,
        expandSupplierFactory: duplicateDetails.expandSupplierFactory ?? true,
      });
    } else if (basedOnPOFromState !== undefined) {
      setPcpCreationState((prev) => ({
        ...prev,
        basedOnPO: basedOnPOFromState,
      }));
    } else if ((!id && !duplicateDetails?._id) || transitioningFromEditToCreate) {
      setPcpCreationState((prev) => ({
        ...prev,
        basedOnPO: prev.basedOnPO ?? false,
      }));
    }
  }, [individualDetail, duplicateDetails, id, basedOnPOFromState]);

  useEffect(() => {
    const prevId = prevIdRef.current;
    const transitioningFromEditToCreate = prevId && !id && !duplicateDetails?._id;

    if (individualDetail && id && !transitioningFromEditToCreate) {
      setAddEditState((oldState) => ({
        ...oldState,
        name: individualDetail?.name,
        brand: checkNullInArrayIds(individualDetail?.brand),
        subBrand: checkNullInArrayIds(individualDetail?.subBrand),
        season: checkNullInArrayIds(individualDetail?.season),
        month: individualDetail?.month,
        year: individualDetail?.year,
        category_1: checkNullInArrayIds(individualDetail?.catOneId),
        category_2: checkNullInArrayIds(individualDetail?.catTwoId),
        category_3: checkNullInArrayIds(individualDetail?.catThreeId),
        category_4: checkNullInArrayIds(individualDetail?.catFourId),
        product_Type: checkNullInArrayIds(individualDetail?.productType),
        suppliers: checkNullInArrayIds(individualDetail?.suppliers),
        status: individualDetail?.status,
        charCount: individualDetail?.name?.length,
        _id: individualDetail?._id || '',
      }));
    } else if (duplicateDetails?._id) {
      setAddEditState((oldState) => ({
        ...oldState,
        name: duplicateDetails?.name,
        brand: checkNullInArrayIds(duplicateDetails?.brand),
        subBrand: checkNullInArrayIds(duplicateDetails?.subBrand),
        season: checkNullInArrayIds(duplicateDetails?.season),
        month: duplicateDetails?.month,
        year: duplicateDetails?.year,
        category_1: checkNullInArrayIds(duplicateDetails?.catOneId),
        category_2: checkNullInArrayIds(duplicateDetails?.catTwoId),
        category_3: checkNullInArrayIds(duplicateDetails?.catThreeId),
        category_4: checkNullInArrayIds(duplicateDetails?.catFourId),
        product_Type: checkNullInArrayIds(duplicateDetails?.productType),
        suppliers: checkNullInArrayIds(duplicateDetails?.suppliers),
        status: duplicateDetails?.status,
        charCount: duplicateDetails?.name?.length,
      }));
    } else if (!id && !duplicateDetails?._id && (!individualDetail || transitioningFromEditToCreate)) {
      setAddEditState((prevState) => ({
        name: '',
        brand: [],
        subBrand: [],
        season: [],
        year: [],
        category_1: [],
        category_2: [],
        category_3: [],
        category_4: [],
        product_Type: [],
        suppliers: [],
        status: [],
        category3List: [],
        category4List: [],
        month: [],
        hasError: false,
        charCount: 0,
        isLoading: false,
        showColumnModal: false,
        selectedTab: null,
        Tabs: [],
        tabId: null,
        selectAllcolumns: false,
        editIndex: -1,
        editTabData: null,
        editColumnData: null,
        _id: '',
        isDragging: false,
        isColumnDragging: false,
        showDeleteConfirmation: false,
        deleteIndex: -1,
        deleteIds: [],
        fromModal: '',
        showRearrangeModal: false,
        showTabDeleteModal: false,
        deleteTab: null,
        subBrandAccess: prevState.subBrandAccess,
      }));
    }
  }, [individualDetail, duplicateDetails, id]);

  const toIds = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val.map((v) => (typeof v === 'object' ? v?._id : v)).filter(Boolean);
    return [typeof val === 'object' ? val?._id : val].filter(Boolean);
  };
  const extractIds = (list) => (Array.isArray(list) ? list.map((x) => x?._id).filter(Boolean) : []);
  const pruneToValid = (sel, valid) => (Array.isArray(sel) ? sel.filter((id) => valid.includes(id)) : []);

  const selPT = toIds(addEditState?.product_Type);
  const selC1 = toIds(addEditState?.category_1);
  const selC2 = toIds(addEditState?.category_2);
  const selC3 = toIds(addEditState?.category_3);

  const filteredC1 = React.useMemo(() => {
    if (!catBasedOnPTData) return category1List;
    if (!selPT.length) return [];
    return (category1List || []).filter((c1) => {
      const rel = c1?.productType || [];
      const arr = Array.isArray(rel) ? rel : [rel];
      return arr.some((id) => selPT.includes(id?._id || id));
    });
  }, [catBasedOnPTData, category1List, selPT]);

  const filteredC2 = React.useMemo(() => {
    if (!catBasedOnPTData) return category2List;
    if (!selC1.length) return [];
    return (category2List || []).filter((c2) => {
      const rel = c2?.categoryOneId || c2?.catOneIds || [];
      const arr = Array.isArray(rel) ? rel : [rel];
      return arr.some((id) => selC1.includes(id?._id || id));
    });
  }, [catBasedOnPTData, category2List, selC1]);

  const filteredC3 = React.useMemo(() => {
    if (!catBasedOnPTData) return addEditState.category3List;
    if (!selC1.length || !selC2.length) return [];
    return (addEditState.category3List || []).filter((c3) => {
      const r1 = c3?.categoryOneId || c3?.catOneIds || [];
      const r2 = c3?.categoryTwoId || c3?.catTwoIds || [];
      const a1 = Array.isArray(r1) ? r1 : [r1];
      const a2 = Array.isArray(r2) ? r2 : [r2];
      const ok1 = a1.some((id) => selC1.includes(id?._id || id));
      const ok2 = a2.some((id) => selC2.includes(id?._id || id));
      return ok1 && ok2;
    });
  }, [catBasedOnPTData, addEditState.category3List, selC1, selC2]);

  const filteredC4 = React.useMemo(() => {
    if (!catBasedOnPTData) return addEditState.category4List;
    if (!selC1.length || !selC2.length || !selC3.length) return [];
    return (addEditState.category4List || []).filter((c4) => {
      const r1 = c4?.categoryOneId || c4?.catOneIds || [];
      const r2 = c4?.categoryTwoId || c4?.catTwoIds || [];
      const r3 = c4?.categoryThreeId || c4?.catThreeIds || [];
      const a1 = Array.isArray(r1) ? r1 : [r1];
      const a2 = Array.isArray(r2) ? r2 : [r2];
      const a3 = Array.isArray(r3) ? r3 : [r3];
      const ok1 = a1.some((id) => selC1.includes(id?._id || id));
      const ok2 = a2.some((id) => selC2.includes(id?._id || id));
      const ok3 = a3.some((id) => selC3.includes(id?._id || id));
      return ok1 && ok2 && ok3;
    });
  }, [catBasedOnPTData, addEditState.category4List, selC1, selC2, selC3]);

  const unionById = (arrA = [], arrB = []) => {
    const map = new Map();
    [...arrA, ...arrB].forEach((item) => {
      if (item && (item._id || item.id)) {
        map.set(item._id || item.id, item);
      }
    });
    return Array.from(map.values());
  };

  const category1UnionOptions = React.useMemo(() => {
    const base = catBasedOnPTData ? filteredC1 : category1List;
    const locked = (individualDetail?.catOneId || []).filter((x) => lockedcat1Ids.includes(x?._id));
    return unionById(base, locked);
  }, [catBasedOnPTData, filteredC1, category1List, lockedcat1Ids]);

  const category2UnionOptions = React.useMemo(() => {
    const base = catBasedOnPTData ? filteredC2 : category2List;
    const locked = (individualDetail?.catTwoId || []).filter((x) => lockedcat2Ids.includes(x?._id));
    return unionById(base, locked);
  }, [catBasedOnPTData, filteredC2, category2List, lockedcat2Ids]);

  const category3UnionOptions = React.useMemo(() => {
    const base = catBasedOnPTData ? filteredC3 : addEditState.category3List;
    const locked = (individualDetail?.catThreeId || []).filter((x) => lockedcat3Ids.includes(x?._id));
    return unionById(base, locked);
  }, [catBasedOnPTData, filteredC3, addEditState.category3List, lockedcat3Ids]);

  const category4UnionOptions = React.useMemo(() => {
    const base = catBasedOnPTData ? filteredC4 : addEditState.category4List;
    const locked = (individualDetail?.catFourId || []).filter((x) => lockedcat4Ids.includes(x?._id));
    return unionById(base, locked);
  }, [catBasedOnPTData, filteredC4, addEditState.category4List, lockedcat4Ids]);

  const handleSelect = (val, key) => {
    const preserveLocked = (nextIds, fieldKey) => {
      if (!id) return nextIds;
      const lockedMap = {
        product_Type: (individualDetail?.productType || []).map((x) => x?._id).filter(Boolean),
        category_1: (individualDetail?.catOneId || []).map((x) => x?._id).filter(Boolean),
        category_2: (individualDetail?.catTwoId || []).map((x) => x?._id).filter(Boolean),
        category_3: (individualDetail?.catThreeId || []).map((x) => x?._id).filter(Boolean),
        category_4: (individualDetail?.catFourId || []).map((x) => x?._id).filter(Boolean),
      };
      const locked = lockedMap[fieldKey] || [];
      return Array.from(new Set([...(nextIds || []), ...locked]));
    };
    if (!catBasedOnPTData) {
      const labelMap = {
        product_Type: 'Product Type',
        category_1: 'Category 1',
        category_2: 'Category 2',
        category_3: 'Category 3',
        category_4: 'Category 4',
      };
      const nextIds = Array.isArray(val) ? val : [];
      onChange(preserveLocked(nextIds, key), labelMap[key]);
      return;
    }
    setAddEditState((prev) => {
      const next = { ...prev };
      if (key === 'product_Type') {
        next.product_Type = preserveLocked([...(val || [])], key);
        const newPTIds = toIds(next.product_Type);
        if (!newPTIds.length) {
          next.category_1 = preserveLocked(toIds(next.category_1), 'category_1');
          next.category_2 = preserveLocked(toIds(next.category_2), 'category_2');
          next.category_3 = preserveLocked(toIds(next.category_3), 'category_3');
          next.category_4 = preserveLocked(toIds(next.category_4), 'category_4');
          return next;
        }
        const validC1Options = (category1List || []).filter((c1) => {
          const rel = c1?.productType || [];
          const arr = Array.isArray(rel) ? rel : [rel];
          return arr.some((rid) => newPTIds.includes(rid?._id || rid));
        });
        next.category_1 = preserveLocked(pruneToValid(toIds(next.category_1), extractIds(validC1Options)), 'category_1');
        const validC2Options = (category2List || []).filter((c2) => {
          const rel = c2?.categoryOneId || c2?.catOneIds || [];
          const arr = Array.isArray(rel) ? rel : [rel];
          return arr.some((rid) => toIds(next.category_1).includes(rid?._id || rid));
        });
        next.category_2 = preserveLocked(pruneToValid(toIds(next.category_2), extractIds(validC2Options)), 'category_2');
        const validC3Options = (prev.category3List || []).filter((c3) => {
          const r1 = c3?.categoryOneId || c3?.catOneIds || [];
          const r2 = c3?.categoryTwoId || c3?.catTwoIds || [];
          const a1 = Array.isArray(r1) ? r1 : [r1];
          const a2 = Array.isArray(r2) ? r2 : [r2];
          const ok1 = a1.some((rid) => toIds(next.category_1).includes(rid?._id || rid));
          const ok2 = a2.some((rid) => toIds(next.category_2).includes(rid?._id || rid));
          return ok1 && ok2;
        });
        next.category_3 = preserveLocked(pruneToValid(toIds(next.category_3), extractIds(validC3Options)), 'category_3');
        const validC4Options = (prev.category4List || []).filter((c4) => {
          const r1 = c4?.categoryOneId || c4?.catOneIds || [];
          const r2 = c4?.categoryTwoId || c4?.catTwoIds || [];
          const r3 = c4?.categoryThreeId || c4?.catThreeIds || [];
          const a1 = Array.isArray(r1) ? r1 : [r1];
          const a2 = Array.isArray(r2) ? r2 : [r2];
          const a3 = Array.isArray(r3) ? r3 : [r3];
          const ok1 = a1.some((rid) => toIds(next.category_1).includes(rid?._id || rid));
          const ok2 = a2.some((rid) => toIds(next.category_2).includes(rid?._id || rid));
          const ok3 = a3.some((rid) => toIds(next.category_3).includes(rid?._id || rid));
          return ok1 && ok2 && ok3;
        });
        next.category_4 = preserveLocked(pruneToValid(toIds(next.category_4), extractIds(validC4Options)), 'category_4');
      }
      if (key === 'category_1') {
        next.category_1 = preserveLocked([...(val || [])], key);
        const v2 = extractIds(filteredC2);
        next.category_2 = preserveLocked(pruneToValid(toIds(next.category_2), v2), 'category_2');
        const v3 = extractIds(filteredC3);
        next.category_3 = preserveLocked(pruneToValid(toIds(next.category_3), v3), 'category_3');
        const v4 = extractIds(filteredC4);
        next.category_4 = preserveLocked(pruneToValid(toIds(next.category_4), v4), 'category_4');
      }
      if (key === 'category_2') {
        next.category_2 = preserveLocked([...(val || [])], key);
        const v3 = extractIds(filteredC3);
        next.category_3 = preserveLocked(pruneToValid(toIds(next.category_3), v3), 'category_3');
        const v4 = extractIds(filteredC4);
        next.category_4 = preserveLocked(pruneToValid(toIds(next.category_4), v4), 'category_4');
      }
      if (key === 'category_3') {
        next.category_3 = preserveLocked([...(val || [])], key);
        const v4 = extractIds(filteredC4);
        next.category_4 = preserveLocked(pruneToValid(toIds(next.category_4), v4), 'category_4');
      }
      if (key === 'category_4') {
        next.category_4 = preserveLocked([...(val || [])], key);
      }
      return next;
    });
  };

  const addColumn = (selectedTab) => {
    setAddEditState((oldState) => ({
      ...oldState,
      showColumnModal: true,
      selectedTab,
    }));
  };

  const onChange = (e, name) => {
    switch (name) {
      case 'cpName':
        setAddEditState((otherState) => ({
          ...otherState,
          name: /^\s/.test(e) ? '' : e,
          charCount: /^\s/.test(e) ? 0 : e.length,
          hasError: false,
        }));
        break;

      case 'Brand':
        setAddEditState((prevState) => {
          const lockedBrandIds = individualDetail?.brand?.map((b) => b._id) || [];
          const updatedSelection = [...new Set([...lockedBrandIds, ...e])];
          return {
            ...prevState,
            brand: updatedSelection || [],
          };
        });
        break;
      case 'Sub Brand':
        setAddEditState((prevState) => {
          const lockedSubBrandIds = individualDetail?.subBrand?.map((b) => b._id) || [];
          const updatedSelection = [...new Set([...lockedSubBrandIds, ...e])];
          return {
            ...prevState,
            subBrand: updatedSelection || [],
          };
        });
        break;

      case 'Months':
        setAddEditState((prevState) => {
          const lockedMonth = individualDetail?.month ? individualDetail?.month : [];
          const updatedSelection = [...new Set([...lockedMonth, ...e])];
          return {
            ...prevState,
            month: updatedSelection || [],
          };
        });
        break;
      case 'Season':
        setAddEditState((prevState) => {
          const lockedSeasonIds = individualDetail?.season?.map((b) => b._id) || [];
          const updatedSelection = [...new Set([...lockedSeasonIds, ...e])];
          return {
            ...prevState,
            season: updatedSelection || [],
          };
        });

        break;
      case 'Year':
        setAddEditState((prevState) => {
          const lockedYear = individualDetail?.year ? individualDetail?.year : [];
          const updatedSelection = [...new Set([...lockedYear, ...e])];
          return {
            ...prevState,
            year: updatedSelection || [],
          };
        });
        break;
      case 'Category 1':
        setAddEditState((prevState) => {
          const updatedSelection = [...new Set([...lockedcat1Ids, ...e])];
          return {
            ...prevState,
            category_1: updatedSelection || [],
            category_3: lockedcat3Ids || [],
            category_4: lockedcat4Ids || [],
            category3List: [],
            category4List: [],
          };
        });
        break;
      case 'Category 2':
        setAddEditState((prevState) => {
          const updatedSelection = [...new Set([...lockedcat2Ids, ...e])];
          return {
            ...prevState,
            category_2: updatedSelection || [],
            category_3: lockedcat3Ids || [],
            category_4: lockedcat4Ids || [],
            category3List: [],
            category4List: [],
          };
        });
        break;
      case 'Category 3':
        setAddEditState((prevState) => {
          const updatedSelection = [...new Set([...lockedcat3Ids, ...e])];
          return {
            ...prevState,
            category_3: updatedSelection || [],
            category_4: lockedcat4Ids || [],
            category4List: [],
          };
        });
        break;
      case 'Category 4':
        setAddEditState((prevState) => {
          const updatedSelection = [...new Set([...lockedcat4Ids, ...e])];
          return {
            ...prevState,
            category_4: updatedSelection || [],
          };
        });
        setAddEditState((otherState) => ({
          ...otherState,
          category_4: [...e],
        }));
        break;
      case 'Product Type':
        setAddEditState((prevState) => {
          const lockedproductTypeIds = individualDetail?.productType?.map((b) => b._id) || [];
          const updatedSelection = [...new Set([...lockedproductTypeIds, ...e])];
          return {
            ...prevState,
            product_Type: updatedSelection || [],
          };
        });
        break;

      case 'Status':
        setAddEditState((prevState) => {
          const lockedStatus = individualDetail?.status ? individualDetail?.status : [];
          const updatedSelection = [...new Set([...lockedStatus, ...e])];
          return {
            ...prevState,
            status: updatedSelection || [],
          };
        });
        break;
      default:
        setAddEditState((prevState) => {
          const lockedproductTypeIds = individualDetail?.suppliers?.map((b) => b._id) || [];
          const updatedSelection = [...new Set([...lockedproductTypeIds, ...e])];
          return {
            ...prevState,
            suppliers: updatedSelection || [],
          };
        });
        break;
    }
  };
  const redirectToListingPage = async () => {
    setAddEditState({
      name: '',
      brand: [],
      subBrand: [],
      season: [],
      year: [],
      category_1: [],
      category_2: [],
      category_3: [],
      category_4: [],
      product_Type: [],
      suppliers: [],
      status: [],
      category3List: [],
      category4List: [],
      month: [],
      hasError: false,
      charCount: 0,
      isLoading: false,
      showColumnModal: false,
      selectedTab: null,
      Tabs: [],
      tabId: null,
      selectAllcolumns: false,
      editIndex: -1,
      editTabData: null,
      editColumnData: null,
      _id: '',
      isDragging: false,
      isColumnDragging: false,
      showDeleteConfirmation: false,
      deleteIndex: -1,
      deleteIds: [],
      fromModal: '',
      showRearrangeModal: false,
      showTabDeleteModal: false,
      deleteTab: null,
    });
    setPcpCreationState({
      basedOnPO: null,
      expandColourway: true,
      expandSupplierFactory: true,
    });
    await dispatch(clearIndividualReducer());
    await dispatch(clearMultiSubBrandData());
    history.push({
      pathname: '/product-cp',
    });
  };

  const redirectToEditPage = (editId) => {
    history.push({
      pathname: `/product-cp/create/${editId}`,
    });
  };

  const checkingNonNullValues = (array) => {
    return array?.filter((ele) => ele);
  };
  const onSubmitMethod = async () => {
    if (
      catBasedOnPTData &&
      id &&
      (addEditState.category_1?.length > 0 ||
        addEditState.category_2?.length > 0 ||
        addEditState.category_3?.length > 0 ||
        addEditState.category_4?.length > 0) &&
      (!addEditState?.product_Type || addEditState?.product_Type?.length === 0)
    ) {
      toasterMsg(t('Product type is required'), 'danger');
      return;
    }
    if (addEditState?.name?.trim().length > 0) {
      if (duplicateDetails?._id) {
        const params = {
          name: addEditState?.name?.trim(),
          season: checkingNonNullValues(addEditState?.season),
          year: addEditState?.year,
          productType: checkingNonNullValues(addEditState?.product_Type),
          brand: checkingNonNullValues(addEditState?.brand),
          subBrand: checkingNonNullValues(addEditState?.subBrand),
          month: addEditState?.month,
          catOneId: checkingNonNullValues(addEditState?.category_1),
          catTwoId: checkingNonNullValues(addEditState?.category_2),
          catThreeId: checkingNonNullValues(addEditState?.category_3),
          catFourId: checkingNonNullValues(addEditState?.category_4),
          suppliers: checkingNonNullValues(addEditState?.suppliers),
          status: checkingNonNullValues(addEditState?.status),
          tabs: addEditState?.Tabs?.map((e) => e?._id),
          duplicatId: duplicateDetails?._id,
          basedOnPO: pcpCreationState.basedOnPO ?? false,
          expandColourway: pcpCreationState.expandColourway ?? true,
          expandSupplierFactory: pcpCreationState.expandSupplierFactory ?? true,
        };
        const res = await dispatch(duplicateProductCard(params, t));
        if (res) {
          dispatch(getIndividualDetails(id));
          redirectToEditPage(res);
        }
      } else {
        const params = {
          name: addEditState?.name?.trim(),
          season: checkingNonNullValues(addEditState?.season),
          year: addEditState?.year,
          productType: checkingNonNullValues(addEditState?.product_Type),
          brand: checkingNonNullValues(addEditState?.brand),
          subBrand: checkingNonNullValues(addEditState?.subBrand),
          month: addEditState?.month,
          catOneId: checkingNonNullValues(addEditState?.category_1),
          catTwoId: checkingNonNullValues(addEditState?.category_2),
          catThreeId: checkingNonNullValues(addEditState?.category_3),
          catFourId: checkingNonNullValues(addEditState?.category_4),
          suppliers: checkingNonNullValues(addEditState?.suppliers),
          status: checkingNonNullValues(addEditState?.status),
          basedOnPO: pcpCreationState.basedOnPO ?? false,
          expandColourway: pcpCreationState.expandColourway ?? true,
          expandSupplierFactory: pcpCreationState.expandSupplierFactory ?? true,
        };
        if (id) {
          params._id = id;
        }
        const res = await dispatch(addProductCard(params, t));
        await dispatch(clearMultiSubBrandData());
        if (res) {
          dispatch(getIndividualDetails(id || res));
          redirectToEditPage(res);
        }
      }
    } else {
      setAddEditState((otherState) => ({
        ...otherState,
        hasError: true,
      }));
    }
  };

  const createTabs = () => {
    const cloneTabs = addEditState.Tabs;
    cloneTabs.push({ name: '', isActive: false, isEditActive: false, isPinned: false });
    setAddEditState((prev) => ({ ...prev, Tabs: cloneTabs }));
  };

  const tabActivateSwitch = async (checked, tabInd) => {
    const cloneTabs = addEditState.Tabs;
    cloneTabs[tabInd].isActive = checked;
    if (cloneTabs[tabInd]?._id) {
      const reqTabObj = {
        ...cloneTabs[tabInd],
        productCPId: id,
        fromActiveInactive: true,
      };
      dispatch(addProductCpTabs(reqTabObj, t));
    }
    setAddEditState((prev) => ({ ...prev, Tabs: cloneTabs }));
  };

  const handleChage = (value, tabInd) => {
    const cloneTabs = addEditState.Tabs;
    cloneTabs[tabInd].name = value;
    cloneTabs[tabInd].hasError = false;
    setAddEditState((prev) => ({ ...prev, Tabs: cloneTabs }));
  };

  const handleSave = (tabObj, tabInd) => {
    if (tabObj?.name?.trim().length > 0) {
      const reqTabObj = {
        ...tabObj,
        productCPId: id,
      };

      const res = dispatch(addProductCpTabs(reqTabObj, t));
      if (res) {
        const cloneTabs = addEditState.Tabs;
        cloneTabs[tabInd].isEditActive = !cloneTabs[tabInd].isEditActive;
        setAddEditState((prev) => ({ ...prev, Tabs: cloneTabs }));
      }
    } else {
      const cloneTabs = addEditState.Tabs;
      cloneTabs[tabInd].hasError = true;
      setAddEditState((prev) => ({ ...prev, Tabs: cloneTabs }));
    }
  };

  const handleEdit = (tabInd) => {
    const cloneTabs = addEditState.Tabs;
    cloneTabs[tabInd].isEditActive = !cloneTabs[tabInd].isEditActive;
    setAddEditState((prev) => ({ ...prev, Tabs: cloneTabs }));
  };
  const handleClose = async () => {
    setAddEditState((oldState) => ({
      ...oldState,
      showColumnModal: false,
      selectedTab: null,
      editColumnData: null,
      editIndex: -1,
    }));
    await dispatch(getAllProductcpTabs({ productCPId: id }));
    dispatch(clearLicenseData());
    dispatch(clearLikenessData());
  };

  const removeTab = async (tabInd, tabId) => {
    if (tabId) {
      setAddEditState((prev) => ({ ...prev, showTabDeleteModal: true, deleteTab: tabId }));
    } else {
      const cloneTabs = addEditState.Tabs;
      cloneTabs.splice(tabInd, 1);
      setAddEditState((prev) => ({ ...prev, Tabs: cloneTabs }));
    }
  };

  const handleEditColumn = (col, tabId, tab) => {
    setAddEditState((oldState) => ({
      ...oldState,
      showColumnModal: true,
      editColumnData: col,
      tabId,
      selectedTab: tab,
    }));
  };

  const handleDelete = (colIds, isFromMainDeleteBtn) => {
    setAddEditState((oldState) => ({
      ...oldState,
      showDeleteConfirmation: true,
      deleteIds: colIds,
      isFromMainDeleteBtn,
    }));
  };
  const toggleDeleteConfirmed = async () => {
    setAddEditState((oldState) => ({
      ...oldState,
      deleteIds: [],
      showDeleteConfirmation: false,
    }));
  };

  const columnDeleteConfirmed = async () => {
    const params = {
      columnIds: addEditState.deleteIds,
    };
    const res = await dispatch(deleteTabsColumns(params, t));
    if (res) {
      dispatch(getAllProductcpTabs({ productCPId: id }));
      toggleDeleteConfirmed();
    }
  };

  const handleActiveInactive = async (col) => {
    const params = {
      columnId: col?._id,
      isActive: !col?.isActive,
    };
    const res = await dispatch(activeInactiveAction(params, t));
    if (res) {
      dispatch(getAllProductcpTabs({ productCPId: id }));
    }
  };

  const handleSelectAllColumnOfTabs = useCallback(
    (isChecked, tabInd) => {
      const cloneTabs = addEditState.Tabs;
      const selectedColIds = cloneTabs[tabInd]?.columns?.map((vl) => vl?._id);
      if (isChecked) {
        cloneTabs[tabInd].selectedColIds = selectedColIds;
      } else {
        cloneTabs[tabInd].selectedColIds = [];
      }
      cloneTabs[tabInd].selectedAll = isChecked;
      setAddEditState((prev) => ({
        ...prev,
        Tabs: cloneTabs,
      }));
    },
    [addEditState.Tabs],
  );

  const handleCheckOdColumns = useCallback(
    (isChecked, colId, tabInd) => {
      const cloneTabs = addEditState.Tabs;
      let prevSelectedIds = cloneTabs[tabInd]?.selectedColIds || [];
      if (isChecked) {
        prevSelectedIds.push(colId);
      } else {
        prevSelectedIds = prevSelectedIds?.filter((prevId) => prevId !== colId);
      }
      cloneTabs[tabInd].selectedColIds = prevSelectedIds;
      if (cloneTabs[tabInd]?.columns?.length === prevSelectedIds?.length) {
        cloneTabs[tabInd].selectedAll = true;
      } else {
        cloneTabs[tabInd].selectedAll = false;
      }
      setAddEditState((prev) => ({
        ...prev,
        Tabs: cloneTabs,
      }));
    },
    [addEditState.Tabs],
  );

  let getSelectedColIds = [];
  addEditState.Tabs?.forEach((tab) => {
    if (tab?.selectedColIds) getSelectedColIds = concat(getSelectedColIds, tab?.selectedColIds);
  });

  const handleRearrangeTabs = () => {
    setAddEditState((oldState) => ({
      ...oldState,
      showRearrangeModal: true,
    }));
  };

  const toggleRearrangeModal = () => {
    setAddEditState((oldState) => ({
      ...oldState,
      showRearrangeModal: false,
    }));
  };

  const handleSaveSequence = async (list) => {
    const tabArraySeq = list?.sequence;
    const updateTabs = addEditState?.Tabs?.map((tab) => {
      tab.sequence = tabArraySeq?.find((ele) => ele?._id === tab?._id)?.sequence;
      return tab;
    });
    updateTabs.sort((a, b) => {
      return a.sequence - b.sequence;
    });
    const res = await dispatch(rearrangeTabs({ tabs: tabArraySeq, productCPId: id }, t));
    if (res) {
      setAddEditState((oldState) => ({
        ...oldState,
        showRearrangeModal: false,
        Tabs: updateTabs,
      }));
      await dispatch(getAllProductcpTabs({ productCPId: id }));
    }
  };

  const toggleTabDelete = () => {
    setAddEditState((oldState) => ({
      ...oldState,
      showTabDeleteModal: false,
      deleteTab: null,
    }));
  };

  const tabDeleteConfirm = async () => {
    const tabId = addEditState?.deleteTab;
    const res = await dispatch(deletePCPTabs({ tabId }, t));
    if (res) {
      const cloneTabs = addEditState.Tabs;
      const tabInd = cloneTabs.findIndex((tab) => tab?._id === tabId);
      cloneTabs.splice(tabInd, 1);
      setAddEditState((prev) => ({ ...prev, Tabs: cloneTabs }));
      toggleTabDelete();
    }
  };

  const handleTabOpenClose = (tabId) => {
    if (arrayDirection.includes(tabId)) {
      setArrayDirection(arrayDirection.filter((ele) => ele !== tabId));
    } else {
      setArrayDirection([...arrayDirection, tabId]);
    }
  };

  return (
    <>
      <div className="page-title-filter sticky ">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('PRODUCT_CRITICAL_PATH.CRITICAL_TITLE')}</h4>
          <div className="position-relative">
            <input
              type="text"
              name="ProductCriticalPathName"
              placeholder={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.TITLE')}
              value={addEditState?.name}
              className="form-control text-bordered w-300 h-30 f-14 ml-1"
              maxLength={30}
              onChange={(e) => onChange(e?.target?.value, 'cpName')}
            />
            <div className="text-count d-none d-md-flex f-14 fixed-bottom-right">{addEditState?.charCount}/30</div>
            {addEditState?.hasError && !addEditState?.charCount && (
              <span className="error-message absolute-right px-2">{t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.NAME_REQUIRED_ERROR')}</span>
            )}
          </div>
        </div>
        <div className="search-filter action-new-row">
          <CustomTooltip placement="top" tooltipText={t('APPROVE_REJECTS.BACK')}>
            <button onClick={redirectToListingPage} aria-label="Close" className="btn d-inline-flex" type="button">
              <span className="icon-close cursor-pointer  f-24" />
            </button>
          </CustomTooltip>
        </div>
      </div>
      <Container className="mt-24 main-cp" fluid>
        <Row className="form-row row-col-5">
          <Col lg={3}>
            <NewCommonMultiSelect
              label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.BRAND')}
              onChange={onChange}
              selectedValue={addEditState.brand}
              optionList={brandList.map((brand) => ({
                ...brand,
                disabled: id ? individualDetail?.brand?.find((selected) => selected?._id === brand?._id) : false,
              }))}
              selectLabel="name"
              selectValue="_id"
            />
          </Col>
          {addEditState.subBrandAccess && (
            <Col lg={3}>
              <NewCommonMultiSelect
                label="Sub Brand"
                onChange={onChange}
                selectedValue={addEditState.subBrand}
                optionList={multiSubBrandList
                  ?.filter((subBrand) => subBrand?.isActive)
                  ?.map((subBrand) => ({
                    ...subBrand,
                    disabled: id ? individualDetail?.subBrand?.find((selected) => selected?._id === subBrand?._id) : false,
                  }))}
                selectLabel="name"
                selectValue="_id"
              />
            </Col>
          )}
          <Col lg={3}>
            <NewCommonMultiSelect
              label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.SEASON')}
              onChange={onChange}
              selectedValue={addEditState.season}
              optionList={seasonList.map((season) => ({
                ...season,
                disabled: id ? individualDetail?.season?.find((selected) => selected?._id === season?._id) : false,
              }))}
              selectLabel="name"
              selectValue="_id"
            />
          </Col>
          <Col lg={3}>
            <NewCommonMultiSelect
              label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.YEAR')}
              onChange={onChange}
              selectedValue={addEditState.year}
              optionList={YearsWithId()?.map((year) => ({
                ...year,
                disabled: id ? individualDetail?.year?.find((selected) => selected === year?._id) : false,
              }))}
              selectLabel="name"
              selectValue="_id"
              scrollToCurrentYear
            />
          </Col>
          <Col lg={3}>
            <NewCommonMultiSelect
              label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.MONTHS')}
              onChange={onChange}
              selectedValue={addEditState.month}
              optionList={months?.map((month) => ({
                ...month,
                disabled: individualDetail?.month?.find((selected) => selected === month?._id),
              }))}
              selectLabel="name"
              selectValue="_id"
            />
          </Col>
          <Col lg={3}>
            <NewCommonMultiSelect
              label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.PRODUCT_TYPE')}
              onChange={(val) => handleSelect(val, 'product_Type')}
              selectedValue={addEditState.product_Type}
              optionList={pcTypeList.map((pcpdata) => ({
                ...pcpdata,
                disabled: id ? individualDetail?.productType?.find((selected) => selected?._id === pcpdata?._id) : false,
              }))}
              selectLabel="name"
              selectValue="_id"
              required={!!catBasedOnPTData}
            />
          </Col>
          <Col lg={3}>
            <NewCommonMultiSelect
              label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.CATEGORY_1')}
              onChange={(val) => handleSelect(val, 'category_1')}
              selectedValue={addEditState.category_1}
              optionList={category1UnionOptions
                .filter((cat1) => cat1?.isActive)
                .map((cat1) => ({
                  ...cat1,
                  disabled: id ? individualDetail?.catOneId?.some((selected) => selected?._id === cat1?._id) : false,
                }))}
              valueSupportList={category1UnionOptions}
              selectLabel="name"
              selectValue="_id"
            />
          </Col>
          <Col lg={3}>
            <NewCommonMultiSelect
              label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.CATEGORY_2')}
              onChange={(val) => handleSelect(val, 'category_2')}
              selectedValue={addEditState.category_2}
              optionList={category2UnionOptions
                .filter((cat2) => cat2?.isActive)
                .map((cat2) => ({
                  ...cat2,
                  disabled: id ? individualDetail?.catTwoId?.find((selected) => selected?._id === cat2?._id) : false,
                }))}
              valueSupportList={category2UnionOptions}
              selectLabel="name"
              selectValue="_id"
            />
          </Col>
          <Col lg={3}>
            <NewCommonMultiSelect
              label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.CATEGORY_3')}
              onChange={(val) => handleSelect(val, 'category_3')}
              selectedValue={addEditState.category_3}
              optionList={category3UnionOptions
                .filter((cat3) => cat3?.isActive)
                .map((cat3) => ({
                  ...cat3,
                  disabled: id ? individualDetail?.catThreeId?.find((selected) => selected?._id === cat3?._id) : false,
                }))}
              valueSupportList={category3UnionOptions}
              selectLabel="name"
              selectValue="_id"
            />
          </Col>
          <Col lg={3}>
            <NewCommonMultiSelect
              label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.CATEGORY_4')}
              onChange={(val) => handleSelect(val, 'category_4')}
              selectedValue={addEditState.category_4}
              optionList={category4UnionOptions
                .filter((cat4) => cat4?.isActive)
                .map((cat4) => ({
                  ...cat4,
                  disabled: id ? individualDetail?.catFourId?.find((selected) => selected?._id === cat4?._id) : false,
                }))}
              valueSupportList={category4UnionOptions}
              selectLabel="name"
              selectValue="_id"
            />
          </Col>

          <Col lg={3}>
            <NewCommonMultiSelect
              label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.SUPPLIER')}
              onChange={onChange}
              selectedValue={addEditState.suppliers}
              optionList={supplierList.map((pcpdata) => ({
                ...pcpdata,
                disabled: id ? individualDetail?.suppliers?.find((selected) => selected?._id === pcpdata?._id) : false,
              }))}
              selectLabel="name"
              selectValue="_id"
            />
          </Col>
          <Col lg={3}>
            <NewCommonMultiSelect
              label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.STATUS')}
              onChange={onChange}
              selectedValue={addEditState.status}
              optionList={productStatusList.map((status) => ({
                ...status,
                disabled: id ? individualDetail?.status?.find((selected) => selected === status?._id) : false,
              }))}
              selectLabel="name"
              selectValue="_id"
            />
          </Col>
          {pcpCreationState.basedOnPO === false && (
            <>
              <Col lg={3}>
                <div className="d-flex align-items-center design-switch">
                  <input
                    type="checkbox"
                    className="form-check-input comment-switch-input mt-0"
                    id="expandColourwaySwitch"
                    name="expandColourwaySwitch"
                    checked={pcpCreationState.expandColourway ?? true}
                    onChange={(e) => setPcpCreationState((prev) => ({ ...prev, expandColourway: e.target.checked }))}
                    disabled={!!id && !duplicateDetails?._id}
                  />
                  <label className="switch-text font-heavy" htmlFor="expandColourwaySwitch">
                    {t('PRODUCT_CRITICAL_PATH.PRODUCT_CRITICAL_PATH_INDEX.PCP_EXPAND_COLOURWAY')}
                  </label>
                </div>
              </Col>
              <Col lg={3}>
                <div className="d-flex align-items-center design-switch">
                  <input
                    type="checkbox"
                    className="form-check-input comment-switch-input mt-0"
                    id="expandSupplierFactorySwitch"
                    name="expandSupplierFactorySwitch"
                    checked={pcpCreationState.expandSupplierFactory ?? true}
                    onChange={(e) => setPcpCreationState((prev) => ({ ...prev, expandSupplierFactory: e.target.checked }))}
                    disabled={!!id && !duplicateDetails?._id}
                  />
                  <label className="switch-text font-heavy" htmlFor="expandSupplierFactorySwitch">
                    {t('PRODUCT_CRITICAL_PATH.PRODUCT_CRITICAL_PATH_INDEX.PCP_EXPAND_SUPPLIER_FACTORY')}
                  </label>
                </div>
              </Col>
            </>
          )}
        </Row>

        {id ? (
          <>
            <div className="floting-actions">
              {productAddEditAccess && !duplicateDetails?._id && (
                <>
                  <CustomTooltip placement="top" tooltipText={t('PRODUCT_CRITICAL_PATH.PRODUCT_COLOUM_BUTTONS.TAB')}>
                    <button type="button" className="btn" onClick={createTabs} aria-label="Download PCP">
                      <i className="icon-add" />
                    </button>
                  </CustomTooltip>
                  {productDeleteAccess && (
                    <CustomTooltip placement="top" tooltipText={t('COMPONENT.FILTER_ACTION.BTN_DELETE.DELETE')}>
                      <button
                        onClick={() => handleDelete([...getSelectedColIds], true)}
                        disabled={addEditState?.Tabs?.filter((e) => !e?._id)?.length > 0 || duplicateDetails?.fromArchive}
                        className="btn"
                        aria-label={t('COMPONENT.FILTER_ACTION.BTN_DELETE.DELETE')}
                        type="button"
                      >
                        <i className="icon-delete" />
                      </button>
                    </CustomTooltip>
                  )}
                  {productAddEditAccess && (
                    <CustomTooltip placement="top" tooltipText={t('PRODUCT_CRITICAL_PATH.PRODUCT_COLOUM_BUTTONS.REARRANGE')}>
                      <button
                        type="button"
                        className="btn"
                        disabled={addEditState?.Tabs?.filter((e) => !e?._id)?.length > 0 || isEmpty(addEditState?.Tabs)}
                        onClick={handleRearrangeTabs}
                        aria-label={t('PRODUCT_CRITICAL_PATH.PRODUCT_COLOUM_BUTTONS.REARRANGE')}
                      >
                        <i className="icon-Rearrange" />
                      </button>
                    </CustomTooltip>
                  )}
                </>
              )}
              <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.SAVE')}>
                <button
                  type="button"
                  className="btn"
                  onClick={onSubmitMethod}
                  aria-label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.SAVE_BUTTON')}
                  disabled={duplicateDetails?.fromArchive || duplicateDetails?.name === addEditState?.name}
                >
                  <i className="icon-Save-1" />
                </button>
              </CustomTooltip>
            </div>
            <div className="collapse-card add-bom-accordion mt-3">
              {Array.isArray(addEditState.Tabs) && !isEmpty(addEditState.Tabs)
                ? addEditState.Tabs?.map((tab, ind) => {
                    return (
                      <Accordion className="mb-3" key={tab?._id || ind}>
                        <Card className="bom-add-card">
                          <Card.Header>
                            <div className="d-inline-flex align-items-center design-switch mt-0">
                              <input
                                type="checkbox"
                                className="form-check-input comment-switch-input mt-0"
                                id={`customSwitch${ind}`}
                                name="commentSwitch"
                                checked={tab?.isActive}
                                onChange={(e) => tabActivateSwitch(e.target.checked, ind)}
                                disabled={!productAddEditAccess}
                              />
                              <label className="switch-text font-heavy align-items-center ">
                                {tab?._id && !tab?.isEditActive ? (
                                  <span className="d-block mt-03">{tab?.name}</span>
                                ) : (
                                  <input type="text" value={tab?.name} onChange={(e) => handleChage(e.target.value, ind)} />
                                )}
                              </label>
                            </div>
                            {tab?.hasError && (
                              <span className="error-message px-2">{t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.TAB_NAME_REQUIRED')}</span>
                            )}
                            <div className="cp-card-action">
                              {productAddEditAccess && (
                                <CustomTooltip
                                  tooltipText={tab?._id && !tab?.isEditActive ? t('PRODUCT_CRITICAL_PATH.MOVING_COLUMN_CARDS.EDIT') : t('COMMON_LABEL.SAVE')}
                                >
                                  <button
                                    type="button"
                                    title={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.SAVE_BUTTON')}
                                    className="btn d-inline-flex p-0 mr-16 ml-0"
                                    onClick={() => {
                                      tab?._id && !tab?.isEditActive ? handleEdit(ind) : handleSave(tab, ind);
                                    }}
                                  >
                                    {tab?._id && !tab?.isEditActive ? <span className="icon-Edit-1 f-24" /> : <span className="icon-Save-1 f-24" />}
                                  </button>
                                </CustomTooltip>
                              )}
                              {tab?._id && (
                                <CustomTooltip tooltipText={t('PRODUCT_CRITICAL_PATH.PRODUCT_COLOUM_BUTTONS.ADD')}>
                                  <button
                                    type="button"
                                    className="btn d-inline-flex p-0 mr-16"
                                    onClick={() => addColumn(tab)}
                                    disabled={!productAddEditAccess || !tab?.isActive}
                                    aria-label={t('PRODUCT_CRITICAL_PATH.PRODUCT_COLOUM_BUTTONS.ADD')}
                                  >
                                    <i className="icon-add f-24" />
                                  </button>
                                </CustomTooltip>
                              )}
                              {productAddEditAccess && (
                                <CustomTooltip tooltipText={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.DELETE')}>
                                  <button
                                    aria-label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.DELETE')}
                                    type="button"
                                    className="btn d-inline-flex p-0"
                                    onClick={() => removeTab(ind, tab?._id)}
                                  >
                                    <span className="icon-Delete f-24" />
                                  </button>
                                </CustomTooltip>
                              )}
                              {tab?._id && (
                                <Accordion.Toggle
                                  className="btn-toggle text-decoration-none text-dark"
                                  as={Button}
                                  variant="link"
                                  eventKey={tab.isActive}
                                  onClick={() => handleTabOpenClose(tab?._id)}
                                >
                                  <i className={arrayDirection?.includes(tab?._id) ? 'icon-new-down-arrow-icon inverse' : 'icon-new-down-arrow-icon '} />
                                </Accordion.Toggle>
                              )}
                            </div>
                          </Card.Header>
                          <Accordion.Collapse eventKey={tab?.isActive}>
                            <Card.Body className="common-border-top card-body">
                              <div className="table-responsive">
                                <RenderProductCpColumnsTable
                                  columns={tab?.columns}
                                  index={ind}
                                  handleEditColumn={(col) => handleEditColumn(col, tab._id, tab)}
                                  handleDelete={handleDelete}
                                  handleActiveInactive={handleActiveInactive}
                                  handleSelectAllColumnOfTabs={(e) => handleSelectAllColumnOfTabs(e.target.checked, ind)}
                                  selectedColIds={tab?.selectedColIds}
                                  selectedAll={tab?.selectedAll}
                                  handleCheckOdColumns={(checked, colId) => handleCheckOdColumns(checked, colId, ind)}
                                  disableButtons={duplicateDetails?._id}
                                  tabId={tab._id}
                                />
                              </div>
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      </Accordion>
                    );
                  })
                : ''}
            </div>
          </>
        ) : (
          <div className="floting-actions">
            <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.SAVE')}>
              <button
                type="button"
                className="btn"
                onClick={onSubmitMethod}
                aria-label={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.SAVE_BUTTON')}
                disabled={duplicateDetails?.fromArchive || duplicateDetails?.name === addEditState?.name}
              >
                <i className="icon-Save-1" />
              </button>
            </CustomTooltip>
          </div>
        )}
      </Container>
      {addEditState.showColumnModal && (
        <AddEditColumn parentData={addEditState} handleClose={handleClose} selectedTab={addEditState?.selectedTab} colEditData={addEditState.editColumnData} />
      )}
      {addEditState?.showDeleteConfirmation && (
        <ConfirmationPopup
          onOpen={addEditState?.showDeleteConfirmation}
          onConfirm={columnDeleteConfirmed}
          title={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.DELETE_COLUMN')}
          message={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.DELETE_COLUMN_CONFIRMATION')}
          secondMessage={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.DELETE_COLUMN_SECOND_MESSAGE')}
          toggle={toggleDeleteConfirmed}
          showCheckBox
          loading={addEditState.isLoading}
        />
      )}
      {addEditState.showRearrangeModal && (
        <DragDrogRearrange
          isShow={addEditState.showRearrangeModal}
          saveSequence={handleSaveSequence}
          isToggle={toggleRearrangeModal}
          itemList={addEditState?.Tabs}
          forTabs
        />
      )}
      {addEditState?.showTabDeleteModal && (
        <ConfirmationPopup
          onOpen={addEditState?.showTabDeleteModal}
          onConfirm={tabDeleteConfirm}
          title={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.DELETE_TAB')}
          message={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.DELETE_TAB_CONFIRMATION')}
          secondMessage={t('PRODUCT_CRITICAL_PATH.ADD_EDIT_PRODUCT_CRITICAL_PATH.DELETE_TAB_SECOND_MESSAGE')}
          toggle={toggleTabDelete}
          showCheckBox
          loading={addEditState.isLoading}
        />
      )}
    </>
  );
}

export default AddEditProductCP;
